import { useMemo } from 'react';

import { Drawer, DrawerContent, DrawerTitle } from 'design-system';

import { AppForm } from '@/features/dashboard/components/AppForm/AppForm';
import { ConfirmationDialog } from '@/features/dashboard/components/ConfirmationDialog';
import {
  DrawerStep,
  useDrawerSteps
} from '@/features/dashboard/components/Drawer/context/DrawerStepsContext';
import { AppSelector } from '@/features/dashboard/components/Drawer/steps/AppSelector';
import { ImportMarketWidget } from '@/features/dashboard/components/Drawer/steps/ImportMarketWidget';

import { dashboardConfirmationPresets } from '../ConfirmationDialog/presets';

export const DashboardDrawer = () => {
  const { drawerStep, confirmOpen, handleAttemptClose, handleConfirmClose, handleCancelClose } =
    useDrawerSteps();

  const content = useMemo(() => {
    switch (drawerStep) {
      case DrawerStep.SelectApp:
        return <AppSelector />;
      case DrawerStep.SelectMarketWidget:
        return <ImportMarketWidget />;
      default:
        return <AppForm />;
    }
  }, [drawerStep]);

  return (
    <>
      <Drawer
        open={Boolean(drawerStep)}
        onOpenChange={nextOpen => {
          if (!nextOpen) handleAttemptClose();
        }}
      >
        <DrawerContent className='max-w-[845px]'>
          <DrawerTitle className='sr-only'>Dashboard app drawer</DrawerTitle>
          {content}
        </DrawerContent>
      </Drawer>
      <ConfirmationDialog
        open={confirmOpen}
        {...dashboardConfirmationPresets.discard}
        onCancel={handleCancelClose}
        onConfirm={handleConfirmClose}
      />
    </>
  );
};
